import React from "react";
import { Typography, Button, notification, Flex, Row, Col } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useRoleCheck from "utilities/hooks/roleCheck";
import axiosInstance from "utilities/axios";

const { Title, Text } = Typography;

const DivisionName = ({ division, onChange }) => {
  const navigate = useNavigate();
  const { hasPermission } = useRoleCheck();

  const changeDivisionName = (e) => {
    if (e !== division.divisionName) {
      axiosInstance
        .put(`/divisions/${division.divisionCode}`, {
          divisionName: e
        })
        .then((response) => {
          notification.success({
            message: "Division Name Updated",
            description: "Division Name has been successfully updated",
          });
          onChange();
        })
        .catch((error) => {
          notification.error({
            message: "Failed to update Division Name",
            description: error.response.data.error,
          });
        });
    }
  };

  const changeDivisionCode = (e) => {
    if (e !== division.divisionCode) {
      axiosInstance
        .put(`/divisions/${division.divisionCode}`, {
          divisionCode: e
        })
        .then((response) => {
          notification.success({
            message: "Division Code Updated",
            description: "Division Code has been successfully updated",
          });
          navigate(`/divisions/${e}`);
        })
        .catch((error) => {
          notification.error({
            message: "Failed to update Division Code",
            description: error.response.data.error,
          });
        });
    }
  };

  if (!division) return null;

  return (
    <>
      <Flex align="center">
        <Row>
          <Col span={24}>
            <Title
              editable={
                hasPermission(
                  ["Admin.Manage"],
                  [],
                  null,
                  false
                )
                  ? {
                      icon: <Button type="text" icon={<EditOutlined />} />,
                      onChange: changeDivisionCode,
                      tooltip: "Edit Division Code",
                    }
                  : false
              }
              level={2}
              style={{ margin: 0, marginRight: 24, height: 48 }}
            >
              {division.divisionCode}
            </Title>
          </Col>
          <Col span={24}>
            <Text type="secondary">Division Code</Text>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Title
              editable={
                hasPermission(
                  ["Admin.Manage"],
                  [],
                  null,
                  false
                )
                  ? {
                      icon: <Button type="text" icon={<EditOutlined />} />,
                      onChange: changeDivisionName,
                      tooltip: "Edit Division Name",
                    }
                  : false
              }
              level={2}
              style={{ margin: 0, height: 48 }}
            >
              {division.divisionName}
            </Title>
          </Col>
          <Col span={24}>
            <Text type="secondary">Division Name</Text>
          </Col>
        </Row>
      </Flex>
    </>
  );
};

export default DivisionName;
